<template>
  <div class="mobile-me-page">
    <van-nav-bar title="我的" fixed placeholder />
    <div class="page-content">
      <!-- 顶部用户信息卡片 -->
      <div class="user-card">
        <div class="avatar">
          {{ avatarText }}
        </div>
        <div class="user-info">
          <div class="real-name">
            {{ user.realName || '未设置姓名' }}
          </div>
          <div class="username">
            {{ user.username || '-' }}
          </div>
          <div class="role-tag">
            学员
          </div>
        </div>
      </div>

      <!-- 快捷导航宫格 -->
      <van-grid :column-num="4" clickable class="quick-grid">
        <van-grid-item
            icon="home-o"
            text="概览"
            @click="$router.push('/m/student/home')"
        />
        <van-grid-item
            icon="edit"
            text="练题"
            @click="$router.push('/m/student/practice')"
        />
        <van-grid-item
            icon="records"
            text="考试"
            @click="$router.push('/m/student/exam')"
        />
        <van-grid-item
            icon="warning-o"
            text="错题"
            @click="$router.push('/m/student/wrong')"
        />
      </van-grid>

      <!-- 用户信息展示列 -->
      <van-cell-group inset class="cell-card">
        <van-cell title="账号" :value="user.username || '-'" />
        <van-cell title="姓名" :value="user.realName || '-'" />
        <van-cell title="当前科目" :value="user.subjectName || '未绑定'" />
        <!-- 夜间模式切换开关 -->
        <van-cell title="夜间模式" center>
          <template #right-icon>
            <van-switch :value="isDarkMode" size="20" @change="toggleDarkMode" />
          </template>
        </van-cell>
      </van-cell-group>

      <!-- 操作列 -->
      <van-cell-group inset class="cell-card">
        <van-cell
            title="退出登录"
            label="清除当前账号信息"
            is-link
            class="logout-cell"
            @click="handleLogout"
        />
      </van-cell-group>

      <div class="version-text">
        驾考学习系统 v1.0.0
      </div>
    </div>
  </div>
</template>

<script>
import { Toast, Dialog } from 'vant'
import { logout } from '@/api/auth'
import { removeToken } from '@/utils/auth'
import { reportOnlineStatus } from '@/api/student/onlineStatus'

export default {
  name: 'MobileStudentMe',
  computed: {
    user() {
      return this.$store.state.userInfo || {}
    },
    avatarText() {
      const name = this.user.realName || this.user.username || '学'
      return name.substring(0, 1)
    },
    // 从 Vuex 动态读取状态
    isDarkMode() {
      return this.$store.state.isDarkMode
    }
  },
  created() {
    this.reportIdleStatus()
  },
  methods: {
    // 触发 Vuex 的切换 mutation
    toggleDarkMode() {
      this.$store.commit('TOGGLE_DARK_MODE')
    },

    async reportIdleStatus() {
      try {
        await reportOnlineStatus('IDLE')
      } catch (e) {
        console.log('状态上报异常', e)
      }
    },

    async handleLogout() {
      try {
        await Dialog.confirm({
          title: '退出确认',
          message: '确定要退出当前账号吗？',
          confirmButtonText: '退出',
          cancelButtonText: '取消'
        })
        try {
          await logout()
        } catch (e) {
          // 忽略退出接口的报错
        }
        removeToken()
        this.$store.commit('CLEAR_USER_INFO')
        Toast.success('已退出登录')
        this.$router.replace('/m/login')
      } catch (e) {
        // 取消退出
      }
    }
  }
}
</script>

<style scoped>
.mobile-me-page {
  min-height: 100vh;
  background: #f5f7fa;
}

.page-content {
  padding: 12px 0 20px;
  box-sizing: border-box;
}

.user-card {
  margin: 0 12px 12px;
  padding: 18px 16px;
  background: #fff;
  border-radius: 14px;
  display: flex;
  align-items: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);
}

.avatar {
  width: 58px;
  height: 58px;
  border-radius: 50%;
  background: #1989fa;
  color: #fff;
  font-size: 26px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.user-info {
  margin-left: 14px;
  flex: 1;
  min-width: 0;
}

.real-name {
  font-size: 18px;
  font-weight: bold;
  color: #303133;
  margin-bottom: 6px;
}

.username {
  color: #606266;
  font-size: 13px;
  margin-bottom: 8px;
}

.role-tag {
  display: inline-block;
  padding: 3px 9px;
  border-radius: 999px;
  background: #ecf5ff;
  color: #1989fa;
  font-size: 12px;
}

.quick-grid {
  margin: 12px;
  border-radius: 12px;
  overflow: hidden;
}

.cell-card {
  margin-top: 12px;
}

.logout-cell {
  color: #ee0a24;
}

.version-text {
  text-align: center;
  color: #c0c4cc;
  font-size: 12px;
  margin-top: 22px;
}
</style>